import { Button, type DropdownTriggerProps, IconButton } from "@mdotm/shadcn/mdotm/components";
import { Icon, type StylableProps } from "@mdotm/shadcn/legacy/components";
import { themeCSSVars } from "@mdotm/shadcn/legacy/themes";
import type { ReactNode } from "react";
import { type ClassList, overrideClassName } from "@mdotm/shadcn/legacy/react-extensions";
import { asyncStateFrom } from "@mdotm/utils/promise";

export function DropdownMenuTrigger({
	children,
	state,
	...forwardProps
}: DropdownTriggerProps & { children?: ReactNode } & StylableProps): React.JSX.Element {
	return (
		<Button state={asyncStateFrom(state)} progressBar={false} palette="secondary" size="small" {...forwardProps}>
			{children}&nbsp;
			<span className="transition-transform data-[state=open]:transform-[rotateX(180deg)] flex">
				<Icon icon="Down" />
			</span>
		</Button>
	);
}

export function TinyDropdownMenuTrigger({
	children,
	state,
	...forwardProps
}: DropdownTriggerProps & { children?: ReactNode } & StylableProps): React.JSX.Element {
	return (
		<Button state={asyncStateFrom(state)} progressBar={false} unstyled {...forwardProps}>
			{children ?? <Icon icon="More" className="rotate-90" size={20} color={themeCSSVars.palette_N500} />}
		</Button>
	);
}

export function DownloadTrigger({ state, ...props }: DropdownTriggerProps) {
	return (
		<Button state={asyncStateFrom(state)} progressBar={false} size="small" palette="neutralOutline" {...props}>
			<Icon icon="Dowload" size={16} />
		</Button>
	);
}

export function WidgetDownloadTrigger({ state, ...props }: DropdownTriggerProps): React.JSX.Element {
	return (
		<IconButton
			icon="Dowload"
			color={themeCSSVars.palette_N500}
			{...props}
			state={asyncStateFrom(state)}
			size={20}
			className={"className" in props ? overrideClassName("p-0!", props.className as ClassList | null) : "p-0!"}
		/>
	);
}
